import React, { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';

import { useMediaQuery } from '@mui/material';
import { toAbsoluteUrl } from '../../../_base';
import '../../../_base/_assets/sass/pages/login/login-1.scss';
import { AuthTabs } from './components';
import { IAppState } from '../../store/rootDuck';
import ChangePasswordPage from './ChangePasswordPage';

export const AuthPage: React.FC = () => {
  const navigate = useNavigate();

  const store = useSelector((store: IAppState) => store, shallowEqual);
  const isMobile = useMediaQuery('(max-width:600px)');

  // check if user is authorized
  useEffect(() => {
    if (store.auth.user) {
      navigate('/');
    }
  }, [store.auth.user]);

  return (
    <div
      className='kt-grid kt-grid--ver kt-grid--root'
      style={{
        minHeight: '100vh',
        maxHeight: '100vh',
        overflowY: 'auto',
      }}
    >
      <div id='kt_login' className='kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1'>
        <div className='kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile'>
          <div
            className='kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside'
            style={{
              backgroundImage: `url(${toAbsoluteUrl('/media/bg/bg-5.jpg')})`,
            }}
          />
          <div className='kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper'>
            <div
              style={{ display: isMobile ? 'initial' : 'flex', justifyContent: 'center' }}
              className='kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver'
            >
              <div
                className='kt-grid__item kt-grid__item--middle'
                style={{ width: isMobile ? '100%' : 450 }}
              >
                <img
                  className='kt-login__title'
                  src={toAbsoluteUrl('/media/logos/chipscan-logo.png')}
                  alt='logo'
                  width={270}
                />
              </div>
            </div>
            <Routes>
              <Route index path='main' element={<AuthTabs />} />
              <Route path='change_password/:code' element={<ChangePasswordPage />} />
              <Route path='*' element={<Navigate to='/auth/main' />} />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
};
